module.exports = __webpack_public_path__ + "img/q3.0ef1f79c.svg";